import "../../css/Home.css";

export default function Home() {
	return (
		<section id="section-home">
			<div className="section-main-content">
				<div className="section-item">
					Frontend Engineer with experience in building high-performing, 
					accessible web applications with TypeScript, Vue/Nuxt, and React.
					Focused on turning ideas into digital experiences by combining creativity
					with strategic execution.
				</div>
			</div>
		</section>
	);
}
